import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import LocalizedStrings from 'react-localization';
import ReactHtmlParser from 'react-html-parser';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import moment from 'moment';
import en from './locales/en.json';
import fr from './locales/fr.json';
import PaymentOptions from '../../Common/PaymentOptions/PaymentOptions';
import NumericalOptions from '../../Common/NumericalOptions/NumericalOptions';
import StripePayment from '../../Common/StripePayment/StripePayment';
import StripePaymentCA from '../../Common/StripePayment/StripePaymentCA';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class EventBilling extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tokenRequested: false,
            hasDevices: false,
        }
    }

    isMinThirteenDaysAway = () => {
        if (this.props.cartItems.length > 0) {
            const closestDate = this.props.cartItems.map(item => {
                if(item.type !== 'flexpass') {
                    return moment(item[0].event_datetime);
                }
            }).reduce((a, b) => Math.min(a, b));
            if(moment(closestDate).diff(moment().add(13, 'days'), 'days') >= 0) {
                return true;
            } else {
                if(this.props.fees_and_discounts.shipping === 'mail') {
                    this.props.handleShippingFee('print');
                }
                return false;
            }
        }
        return true;
    }

    getRequestAccess = async (clientId) => {
        try {
            const requestAccessResponse = await postRequestAccess(clientId);
            console.log('Request Access Response: ', requestAccessResponse);

            if(requestAccessResponse.data.token){
                localStorage.setItem('token', requestAccessResponse.data.token);
                this.setState({ tokenRequested: true })
            } else {
                console.log("Error getting access token");
            }
        } catch (error) {
            console.log(error);
        }

        async function postRequestAccess (clientId) {
            let dataObj = {};
            if(clientId != undefined) {
                dataObj['client_id'] = clientId;
            }
            return await ApiRequest("/tickets/request-access", {
                method: 'POST',
                data: dataObj
            });
        }
    }

    componentDidUpdate() {
        if(this.props.isDonation && !this.state.tokenRequested) {
            let clientId = undefined;
            if (this.props.routeProps) {
                clientId = parseInt(this.props.routeProps.match.params.id);
            }

            this.getRequestAccess(clientId);
        }
    }

    componentDidMount() {
        if (this.props.user.role) {
            this.getDevices();
        }
    }

    getDevices  = async () => {
        try {
            const getReadersResponse = await getReaders();
            console.log('getReadersResponse', getReadersResponse);
            if (getReadersResponse.data.readers) {
                this.setState({
                    hasDevices: true,
                });
            } else {
                this.setState({
                    hasDevices: false,
                });
            }
            //this.setMessage('','','');
        } catch (error) {
            console.log(error);
        }

		async function getReaders() {
			return await ApiRequest(`/stripe/readers`, {
                method: 'GET',
            });
        }
    }

    renderQuestions = () => {
        if (this.props.questions.length > 0) {
            return (
                <div className="col-12 text-left">
                    <div className="showtix-event-questions">
                        {this.props.questions.map((question, i) => {
                            return (
                                <div className="showtix-event-question">
                                    <label
                                        className="showtix-label showtix-event-question__title"
                                        for={"question-" + i}
                                    >
                                        {question.required && <span>*</span>}
                                        {question.question}
                                    </label>
                                    <input
                                        key={i}
                                        className="showtix-input"
                                        object="questions"
                                        id={"question-" + i}
                                        data-questionid={question.id}
                                        value={question.answer}
                                        onChange={(e) => this.props.handleChangeQuestionAnswer(i, e)}
                                    />
                                </div>  
                            )
                        })}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        return (
            <div className="showtix-billing" id="billing-info">
                <div className={"showtix-billing__content " + (this.props.isBillingOpen ? 'is-active' : '')}>
                    <div className="showtix-background__primary-3 showtix-section">
                        <div className="row">
                            <div className="col-12 text-center">
                                {!this.props.isCustomerInfoOpen &&
                                    <button
                                        className="showtix-button showtix-button__xsmall showtix-background__grey-3"
                                        onClick={() => this.props.toggleBilling(false)}
                                        aria-label="Go Back to Ticket Selection"
                                    >{strings.goBack}</button>
                                }
                                <h2 className="showtix-h1">{strings.title}</h2>
                            </div>
                        </div>        
                        <div className="row">
                            {this.props.user.role &&
                                <React.Fragment>
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="billing_fees">{strings.fees}
                                                <span id="tooltip-fees" className="showtix-tooltip">!</span>
                                                <Tooltip placement="top" target="tooltip-fees">
                                                    {ReactHtmlParser(strings.feesTooltip)}
                                                </Tooltip>
                                            </label>
                                            <div className="showtix-form__select">
                                                <select className="showtix-input"
                                                    name="service_fee"
                                                    id="billing_fees"
                                                    value={this.props.service_fee}
                                                    onChange={this.props.handleServiceFee}
                                                >
                                                    <option value="default">Client Default</option>
                                                    <option value="client">No</option>
                                                    <option value="customer">Yes</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="billing_method">{strings.paymentMethods}</label>
                                            {this.props.billing.method === 'reader' && (
                                                this.props.isTerminalConnected ? (
                                                    <span className="showtix-badge showtix-background__success">{JSON.parse(sessionStorage.getItem('connected_device')).label}</span>
                                                ) : (
                                                    <span className="showtix-badge">Connecting...</span>
                                                )
                                                
                                            )}
                                            <div className="showtix-form__select">
                                                <select className="showtix-input"
                                                    object="billing"
                                                    name="method"
                                                    id="billing_method"
                                                    value={this.props.billing.method}
                                                    onChange={this.props.handleEventBilling}
                                                >
                                                    <PaymentOptions />
                                                    {this.state.hasDevices && (
                                                        <option value={'reader'}>POS Terminal</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={"col-12 col-md-6 " + (this.props.billing.method !== 'check' ? 'd-none' : '')}>
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="billing_check">{strings.checkNumber}</label>
                                            <div className="showtix-form__input">
                                                <input
                                                    type="text"
                                                    className="showtix-input"
                                                    id="billing_check"
                                                    object="billing"
                                                    name="check"
                                                    validation="(^(\s*|\d+)$)"
                                                    value={this.props.billing.check}
                                                    onChange={this.props.handleEventBilling}
                                                    onBlur={this.props.validateRequiredField}
                                                    required={this.props.billing.method === 'check'}
                                                />
                                            </div>
                                            {this.props.validation.billing.check && !this.props.validation.billing.check.valid &&
                                                <div className=" showtix-note error text-left">
                                                    {this.props.validation.billing.check.msg}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <hr />
                                    </div>
                                </React.Fragment>
                            }

                            {(this.props.billing.method === 'cash' || this.props.billing.method === 'card' || this.props.billing.method === 'check' || this.props.billing.method === 'reader') &&
                                <React.Fragment>
                                    {this.props.client.donation &&
                                        <div className="col-12 col-md-6">
                                            <div className="showtix-form__group">
                                                <label className="showtix-label" htmlFor="fees_and_discounts_donation">{strings.donation}</label>
                                                <div className="showtix-form__input showtix-form__money">
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        className="showtix-input"
                                                        name="donation"
                                                        id="fees_and_discounts_donation"
                                                        value={this.props.fees_and_discounts.donation === 0 ? '' : this.props.fees_and_discounts.donation}
                                                        onChange={this.props.handleDonationCouponsAndFlexpass}
                                                        onBlur={this.props.applyDonation}
                                                    />
                                                </div>
                                                <div className="showtix-note text-left d-md-none d-lg-none">
                                                    {this.props.client.donation_text}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="billing_coupon">{strings.couponFlexpass}</label>
                                            <div className="showtix-form__input">
                                                <div className="d-flex flex-column flex-md-row flex-wrap">
                                                    <input
                                                        type="text"
                                                        className="showtix-input"
                                                        name="couponFlexpass"
                                                        id="billing_coupon"
                                                        value={this.props.fees_and_discounts.couponFlexpass}
                                                        onChange={this.props.handleDonationCouponsAndFlexpass}
                                                        style={{flex:1}}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="showtix-button showtix-background__primary-1 mt-2 mt-md-0 ml-md-2"
                                                        onClick={this.props.applyCoupon}
                                                        disabled={this.props.fees_and_discounts.coupon === ''}
                                                        aria-label={strings.applyCoupon}
                                                    >
                                                        <span>{strings.apply}</span>
                                                    </button>
                                                </div>
                                            </div>
                                            {(this.props.fees_and_discounts.validCoupon || this.props.fees_and_discounts.flexpass.validFlexpass) &&
                                                <div className="showtix-note text-left showtix-color__primary-1 d-md-none d-lg-none">
                                                    {this.props.fees_and_discounts.validCoupon &&
                                                        <React.Fragment>
                                                            <span className="pr-1" onClick={() => this.props.removeCoupon()}>X</span>
                                                            <span>
                                                                {strings.coupon} {this.props.fees_and_discounts.validCoupon} {strings.applied}
                                                            </span>
                                                        </React.Fragment>
                                                    }
                                                    {this.props.fees_and_discounts.flexpass.validFlexpass &&
                                                        <React.Fragment>
                                                                <span className="pr-1" onClick={() => this.props.removeFlexpass()}>X</span>
                                                                <span>
                                                                    {strings.flexpass} {this.props.fees_and_discounts.flexpass.validFlexpass} {strings.valid}
                                                                </span>
                                                        </React.Fragment>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {this.props.client.donation && (
                                        <div className="col-12 col-md-6" style={{'marginTop': '-10px'}}>
                                            <div className="showtix-form__group d-none d-md-block d-lg-block">
                                                <div className="showtix-note text-left">
                                                    {this.props.client.donation_text}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-12 col-md-6" style={{'marginTop': '-10px'}}>
                                        {(this.props.fees_and_discounts.validCoupon || this.props.fees_and_discounts.flexpass.validFlexpass) &&
                                            <div className="showtix-note text-left showtix-color__primary-1 d-none d-md-block d-lg-block">
                                                {this.props.fees_and_discounts.validCoupon &&
                                                    <React.Fragment>
                                                        <span className="pr-1" onClick={() => this.props.removeCoupon()}>X</span>
                                                        <span>
                                                            {strings.coupon} {this.props.fees_and_discounts.validCoupon} {strings.applied}
                                                        </span>
                                                    </React.Fragment>
                                                }
                                                {this.props.fees_and_discounts.flexpass.validFlexpass &&
                                                    <React.Fragment>
                                                        <span className="pr-1" onClick={() => this.props.removeFlexpass()}>X</span>
                                                        <span>
                                                            {strings.flexpass} {this.props.fees_and_discounts.flexpass.validFlexpass} {strings.valid}
                                                        </span>
                                                    </React.Fragment>
                                                }
                                            </div>
                                        }
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="billing_shipping">{strings.shippingMethod}</label>
                                            <div className="showtix-form__select">
                                                <select className="showtix-input"
                                                    name="shipping"
                                                    id="billing_shipping"
                                                    value={this.props.fees_and_discounts.shipping}
                                                    onChange={(e) => this.props.handleShippingFee(null, e)}
                                                >
                                                    <option value="print">{strings.email} - {strings.free}</option>

                                                    {/* this.isMinThirteenDaysAway() && 
                                                        (this.props.billing.method !== 'cash' && this.props.billing.method !== 'check') 
                                                            &&
                                                            <option value="mail">
                                                                {strings.mail} - {new Intl.NumberFormat('en-US', {
                                                                    style: 'currency',
                                                                    currency: 'USD'
                                                                }).format(this.props.client.shipping_fee)}
                                                            </option>
                                                    */}

                                                    {this.props.client.allow_will_call === true &&
                                                        (!this.props.billing.method !== 'check') 
                                                            &&
                                                            <option value="willcall">{strings.willcall} - {strings.free}</option>
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <hr />
                                    </div>

                                </React.Fragment>
                            }
                            
                            {this.props.isGodMode &&
                                <React.Fragment>
                                    <div className="col-12 col-md-6 text-left">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label">{strings.callCenterFee}</label>

                                            <div className="row">
                                                <div className="col-12 col-md-3">
                                                    <div className="showtix-form__radio">
                                                        <input
                                                            type="radio"
                                                            className="showtix-input"
                                                            id="call_center_fee-1"
                                                            object="billing"
                                                            name="call_center_fee"
                                                            value="true"
                                                            checked={this.props.call_center_fee === true}
                                                            onChange={this.props.setCallCenterFees}
                                                        />
                                                        <label className="showtix-label" htmlFor="call_center_fee-1">{strings.yes}</label>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-3">
                                                    <div className="showtix-form__radio">
                                                        <input
                                                            type="radio"
                                                            className="showtix-input"
                                                            id="call_center_fee-2"
                                                            object="billing"
                                                            name="call_center_fee"
                                                            value="false"
                                                            checked={this.props.call_center_fee === false}
                                                            onChange={this.props.setCallCenterFees}
                                                        />
                                                        <label className="showtix-label" htmlFor="call_center_fee-2">{strings.no}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }

                            {this.renderQuestions()}

                                <React.Fragment>
                                    {/* this.props.fees_and_discounts.flexpass.validFlexpass &&
                                        <React.Fragment>   
                                            <div className="col-12 col-md-6 text-left">
                                                <div className="showtix-form__group">
                                                    <label className="showtix-label" htmlFor="billing_flexpass">{strings.flexpassUse}</label>
                                                    <div className="row no-gutters">
                                                        <div className="showtix-form__select col-12 col-md-3">
                                                            <select 
                                                                className="showtix-input"
                                                                name="flexpass"
                                                                object="amount"
                                                                value={this.props.fees_and_discounts.flexpass.amount}
                                                                onChange={this.props.handleFlexpassAmount}
                                                            >
                                                                <NumericalOptions start="1" end={this.props.fees_and_discounts.tickets_remaining} />
                                                            </select>
                                                        </div>
                                                        <div className="col-12 col-md-9">
                                                            <button
                                                                type="button"
                                                                className="showtix-button showtix-background__primary-1 mt-2 mt-md-0 ml-md-2"
                                                                onClick={() =>this.props.getCartPricing(this.props.user)}
                                                            >
                                                                <span>{strings.apply}</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    */}
                                    {!this.props.user.role &&
                                        <div className="col-12">
                                            <div className="row">
                                                {this.props.isPaymentEnabled && (
                                                     <div className="col">
                                                        <div className="showtix-stripe-payment-request">
                                                            {this.props.client.billing_country === 'US' ? (
                                                                <StripePayment
                                                                    client={this.props.client}
                                                                    cartPricing={this.props.cartPricing}
                                                                    checkoutStripePayment={this.props.checkoutStripePayment}
                                                                    stripeRequestPayment={this.props.stripeRequestPayment}
                                                                    setIsPaymentEnabled={this.props.setIsPaymentEnabled}
                                                                    hasQuestionNotAnswered={this.props.hasQuestionNotAnswered}
                                                                />
                                                            ) : (
                                                                <StripePaymentCA
                                                                    client={this.props.client}
                                                                    cartPricing={this.props.cartPricing}
                                                                    checkoutStripePayment={this.props.checkoutStripePayment}
                                                                    stripeRequestPayment={this.props.stripeRequestPayment}
                                                                    setIsPaymentEnabled={this.props.setIsPaymentEnabled}
                                                                    hasQuestionNotAnswered={this.props.hasQuestionNotAnswered}
                                                                />
                                                            )}
                                                            
                                                        </div>
                                                    </div>
                                                )}
                                               
                                                <div className="col">
                                                    <button
                                                        type="button"
                                                        className="showtix-button showtix-background__primary-1"
                                                        onClick={() => this.props.toggleCustomerInfo(true)}
                                                        disabled={this.props.hasQuestionNotAnswered}
                                                    >
                                                        <span>{strings.checkout}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </React.Fragment>

                            {this.props.user.role &&
                                <React.Fragment>
                                    <div className="col-12 showtix-billing-buttons">
                                        <button
                                            type="button"
                                            className="showtix-button showtix-background__primary-1"
                                            onClick={() => this.props.toggleCustomerInfo(true)}
                                            disabled={(this.props.billing.method === 'reader' && !this.props.isTerminalConnected) || this.props.hasQuestionNotAnswered}
                                        >
                                            <span>{strings.customerInfo}</span>
                                        </button>
                                        {this.props.billing.method !== 'reader' && (
                                            !this.props.hasQuestionNotAnswered && (
                                                <button
                                                    type="button"
                                                className={"showtix-button showtix-background__primary-1 " + (this.props.billing.method === 'card' || this.props.billing.method === 'bulk' || this.props.billing.method === 'reserved' || this.props.billing.method === 'vipatron' || this.props.fees_and_discounts.shipping === 'mail' ? 'd-none' : '')}
                                                    onClick={this.props.checkout}
                                                    disabled={(this.props.billing.method === 'check' && this.props.billing.check === '')
                                                                || (this.props.billing.method === 'check' && this.props.validation.billing.check.valid === false)
                                                                    || (!this.props.cartItems.length > 0 && this.props.fees_and_discounts.donation === 0)}
                                                >
                                                    <span>{strings.checkout}</span>
                                                </button>
                                            )
                                        )}
                                    </div>
                                </React.Fragment>
                            }
                        </div>        
                    </div>   
                </div>
            </div>
        );
    }
}

EventBilling.propTypes = {
    billing: PropTypes.shape({
        donation: PropTypes.string,
        fees: PropTypes.string,
        coupon: PropTypes.string,
        flexpass: PropTypes.number,
        shipping: PropTypes.string,
        method: PropTypes.string,
        check: PropTypes.string,
        coupons: PropTypes.array
    }),
    validation: PropTypes.shape({
        billing: PropTypes.shape({
            donation: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            check: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
        }),
    }),
    is_client: PropTypes.bool,
    isBillingOpen: PropTypes.bool,
    handleEventBilling: PropTypes.func,
    applyCoupon: PropTypes.func,
    removeCoupon: PropTypes.func,
    toggleCustomerInfo: PropTypes.func,
    checkout: PropTypes.func
}

export default EventBilling;


// WEBPACK FOOTER //
// ./src/components/EventListing/EventBilling/EventBilling.js